/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseIconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set/base-icon-set.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';

export const FullIconSetFragment = gql`
  ${BaseIconSetFragment}
  ${IconFragment}

  fragment FullIconSetFragment on IconSet {
    ...BaseIconSetFragment

    iconsCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
  }
`;
